import { render, staticRenderFns } from "./ListaMovimientosPorPaciente.vue?vue&type=template&id=7e72ed50"
import script from "./ListaMovimientosPorPaciente.vue?vue&type=script&lang=js"
export * from "./ListaMovimientosPorPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports